import '@angular/compiler';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalQadatasetQasetComponent } from './portal.qadataset.qaset/portal.qadataset.qaset.component';
import { ComponentDashboardComponent } from './component.dashboard/component.dashboard.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalQadatasetReviewlogComponent } from './portal.qadataset.reviewlog/portal.qadataset.reviewlog.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalQadatasetQainstructverifyComponent } from './portal.qadataset.qainstructverify/portal.qadataset.qainstructverify.component';
import { PortalDashboardAdmindashboardComponent } from './portal.dashboard.admindashboard/portal.dashboard.admindashboard.component';
import { PortalQadatasetVerifyComponent } from './portal.qadataset.verify/portal.qadataset.verify.component';
import { ComponentHeaderComponent } from './component.header/component.header.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { ComponentNavUserComponent } from './component.nav.user/component.nav.user.component';
import { ComponentFooterComponent } from './component.footer/component.footer.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageUipageComponent } from './page.uipage/page.uipage.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { ComponentPaginationComponent } from './component.pagination/component.pagination.component';
import { PortalQadatasetQainstructComponent } from './portal.qadataset.qainstruct/portal.qadataset.qainstruct.component';
import { PortalRawdataListComponent } from './portal.rawdata.list/portal.rawdata.list.component';
import { LayoutUserComponent } from './layout.user/layout.user.component';
import { PageAuthenticateComponent } from './page.authenticate/page.authenticate.component';
import { PortalAdminpageForadminComponent } from './portal.adminpage.foradmin/portal.adminpage.foradmin.component';
import { ComponentMypageComponent } from './component.mypage/component.mypage.component';
import { PortalRawdataDetailComponent } from './portal.rawdata.detail/portal.rawdata.detail.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalDashboardUserdashboardComponent } from './portal.dashboard.userdashboard/portal.dashboard.userdashboard.component';

// const INDEX_PAGE = "main";
const INDEX_PAGE = "/authenticate"

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutUserComponent,
        "children": [
            {
                "path": "ui/:category/:type?/:id?",
                component: PageUipageComponent,
                "app_id": "page.uipage"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "authenticate",
                component: PageAuthenticateComponent,
                "app_id": "page.authenticate"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }